import { Component, ViewChild } from '@angular/core';
import { DialogContentBase, DialogRef } from '@progress/kendo-angular-dialog';
import { StaffSearchComponent } from '../staff-search/staff-search.component';
import { IhmsService } from '../../services/ihms.service';
import { IHMSStudentResponse } from '../../interfaces/ihms-dashboard-response';
import { NotificationService } from '@progress/kendo-angular-notification';
import {
  IhmsNotificationMessageKeys,
  IhmsNotificationMessages,
  NOTIFICATION_MESSAGES,
} from '../../constants/notification-messages';
import { IIhmsSavePayload } from '../../interfaces/ihms-save-payload';
import { ApiResponse } from '../../interfaces/api-response';
import { IhmsActionItems } from '../../enums/ihms-action-items';

@Component({
  selector: 'app-assign-action-item-dialog',
  templateUrl: './assign-action-item-dialog.component.html',
  styleUrls: ['./assign-action-item-dialog.component.scss'],
  standalone: false,
})
export class AssignActionItemDialogComponent extends DialogContentBase {
  @ViewChild('staff', { static: false }) staffSearch: StaffSearchComponent;
  selectedSearch: boolean;
  actionDetails: IHMSStudentResponse;
  loadSpinner: boolean = false;
  studentId: string;
  reassign: boolean = false;
  studentName: string;
  constructor(
    dialogRef: DialogRef,
    private ihmsService: IhmsService,
    private notificationService: NotificationService
  ) {
    super(dialogRef);
  }

  staffSelected(): void {
    this.selectedSearch = true;
  }

  resetSearch(staff: boolean): void {
    if (staff) {
      this.selectedSearch = false;
    }
  }

  onSubmit(): void {
    this.loadSpinner = true;
    const payload: IIhmsSavePayload = {
      // studentId: this.studentId,
      // studentName: this.studentName,
      ihmsid: this.actionDetails.id,
      ihmscaseNo: this.actionDetails.ihmsCaseNo,
      performedBy: '', // send back logged in user
      actionItemId: this.actionDetails.action_Item_Id,
      assigne: this.staffSearch?.selectedStaffForm?.value?.email,
      uiAction: IhmsActionItems.Assigned,
    };
    // TODO: Need to discuss with Veeresh to have this endpoint accept the assigneeName so that when the grid refreshes, it contains the newly populate assignee name
    this.ihmsService.saveIhmsData(payload).subscribe({
      next: (res: ApiResponse<IIhmsSavePayload>) => {
        if (res.isRequestSucessful) {
          const message: string = this.reassign
            ? IhmsNotificationMessages[
                IhmsNotificationMessageKeys.ReassignSuccess
              ](
                this.actionDetails.name,
                this.staffSearch?.selectedStaffForm?.value?.fullName
              )
            : IhmsNotificationMessages[
                IhmsNotificationMessageKeys.AssignSuccess
              ](
                this.actionDetails.name,
                this.staffSearch?.selectedStaffForm?.value?.fullName
              );
          this.notificationService.show({
            content: message,
            cssClass: 'notification-message-class-ihms',
            position: { horizontal: 'center', vertical: 'top' },
            animation: { type: 'slide', duration: 60 },
            type: { style: 'success', icon: true },
            closable: false,
          });
        }
        this.ihmsService.getReloadIhmsGridDetails(true);
        this.dialog.close();
        this.loadSpinner = false;
      },
      error: () => {
        this.loadSpinner = false;
        this.notificationService.show({
          content: NOTIFICATION_MESSAGES.submissionFailed,
          position: { horizontal: 'center', vertical: 'top' },
          animation: { type: 'slide', duration: 60 },
          type: { style: 'error', icon: true },
          closable: true,
        });
      },
    });
  }
}
